const WORKSPACE_DOCUMENT_SOURCE = "workspace";

export function workspaceDocumentHref(fileId: string): string {
  return `/documents/${encodeURIComponent(fileId)}?source=${WORKSPACE_DOCUMENT_SOURCE}`;
}
